import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    tabPanel: {
      padding: "0 !important",
      margin: "0",
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          "& .MuiTableCell-root": {
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          },
          "&:nth-child(even)": {
            backgroundColor: "rgba(5,89,141, 0.1)"
          }
        }
      }
    },
    topHeader: {
      zIndex: 100,
      fontSize: "0.5 rem",
      padding: "10px 20px 10px 10px",
      position: "absolute",
      width: "90%"
    },
    tabHeader: {
      backgroundColor: "#05598d"
    },
    tabEntry: {
      color: "#fff",
      textTransform: "none"
    },
    indicator: {
      backgroundColor: "#e3e9ff"
    },
    toolbar: {
      padding: "0px",
      "& .MuiButtonBase-root": {
        color: "#fff",
        bottom: "12px",
        zIndex: 100
      }
    },
    chip: {
      backgroundColor: "rgb(233, 229, 226)",
      "&:active, &:focus, &:hover": {
        backgroundColor: "rgba(233, 229, 226, 0.9)"
      }
    },
    chipActive: {
      backgroundColor: "rgb(31, 132, 52)",
      color: "#fff",
      "&:active, &:focus, &:hover": {
        backgroundColor: "rgba(31, 132, 52, 0.9)"
      }
    }
  })
);
